import { createApp } from 'vue'
import BlogBackgroundImageSetting from './components/BlogBackgroundImageSetting.vue'
import store from './stores/blogImg'

const app = createApp({
    components: { BlogBackgroundImageSetting },
    props: [
        'isAccessedByMyself',
        'originalPosition',
        'originalFilename',
        'uniqueId',
        'isMobile',
        'domain',
        'csrf'
    ],
})

app.provide("store", store);
app.mount('.header-blog');